module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens34-c5fc0e63e64b4c6df13866fe83727aa2.jpg";